module.exports = __webpack_public_path__ + "img/obj.3c2c996e.png";